export default function(target, value) {
  function push(context) {
    if (!context.resolve.isTag(target, 'state', 'module')) {
      throw new Error(
        'Cerebral operator.push: You have to use the STATE TAG as first argument'
      )
    }

    context[target.type].push(
      context.resolve.path(target),
      context.resolve.value(value)
    )
  }

  push.displayName = `operator.push(${String(target)})`

  return push
}
